import { render, staticRenderFns } from "./DurationFormInput.vue?vue&type=template&id=7254396e&scoped=true&"
import script from "./DurationFormInput.vue?vue&type=script&lang=ts&"
export * from "./DurationFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./DurationFormInput.vue?vue&type=style&index=0&id=7254396e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7254396e",
  null
  
)

export default component.exports